import { useQuery } from '@tanstack/react-query'
import { societyQueries } from '../api/societies'

export const useTicketSettings = (
  societyId?: string
): {
  questionEnabled: boolean
  reportEnabled: boolean
} => {
  const { data: society } = useQuery(societyQueries.getSociety(societyId))

  const widgetIsHidden = (widgetType: string): boolean => {
    if (!society) return false
    if (!society.hiddenSocietyWidgets) {
      return false
    }
    return society.hiddenSocietyWidgets?.includes(widgetType)
  }

  return {
    questionEnabled: !widgetIsHidden('ticket-question'),
    reportEnabled: !widgetIsHidden('ticket-report'),
  }
}
